<template>
  <div class="about-frame">
    <Content :routeArr="routeArr" />

    <div class="box" v-if="!isMobile">
      <ul class="nav">
        <li
          :class="['nav-item', activeCode == item.code ? 'on' : '']"
          v-for="item in $store.state.subList"
          :key="item.id"
          @click="changeList(item)"
        >
          {{ item.name }}
        </li>
      </ul>

      <div class="new-list">
        <div class="new-item" v-for="item in newsList" :key="item.id">
          <div class="video-show" v-show="item.newsType == 1">
            <video
              class="video"
              controls
              :poster="URL + item.newsImageUrl"
              :src="URL + item.linkUrl"
            ></video>
          </div>
          <div class="img-show" v-show="item.newsType == 2">
            <img :src="URL + item.linkUrl" :alt="item.title" />
          </div>
        </div>
      </div>

      <el-pagination
        style="text-align: center; margin-top: 10px"
        @current-change="handleCurrentChange"
        :current-page.sync="params.pageIndex"
        :page-size="params.pageSize"
        layout="total, prev, pager, next"
        :total="newsTotal"
      >
      </el-pagination>
    </div>
    <div class="m-box" v-else>
      <van-tabs v-model="activeCode" @change="toChange">
        <van-tab
          :title="item.name"
          :name="item.code"
          v-for="item in $store.state.subList"
          :key="item.id"
        >
          <div class="new-list">
            <div class="new-item" v-for="item in newsList" :key="item.id">
              <div class="video-show" v-show="item.newsType == 1">
                <video
                  class="video"
                  controls
                  :poster="URL + item.newsImageUrl"
                  :src="URL + item.linkUrl"
                ></video>
              </div>
              <div class="img-show" v-show="item.newsType == 2">
                <img :src="URL + item.linkUrl" :alt="item.title" />
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Content from "@/components/content.vue";

import { sysNewsList } from "../../util/news/news.js";
import { URL } from "../../util/config";
export default {
  data() {
    return {
      URL,
      activeCode: "",
      params: {
        pageIndex: 1,
        pageSize: 10,
        newsCode: "",
        typeCode: "",
      },
      newsList: [],
      newsTotal: 0,
      moduleTitle: "",
      moduleDesc: "", // 模版渲染的标题以及英文翻译
      tabName: "",
      moduleFlag: 1,
      clickConfig: 0,
      routeArr: [],
      isMobile: sessionStorage.getItem("isMobile"),
    };
  },
  components: {
    Content,
  },
  created() {},
  mounted() {
    const code = sessionStorage.getItem("childCode");
    if (code) {
      this.$store.state.subList.forEach((ele) => {
        if (ele.code == code) {
          this.changeList(ele);
        }
      });
      sessionStorage.removeItem("childCode");
    } else {
      this.changeList(this.$store.state.subList[0]);
    }

    this.routeArr = [
      { name: "首页", path: "/" },
      { name: this.$store.state.name, path: "/article" },
    ];
  },
  methods: {
    toChange(name) {
      const trueArr = this.$store.state.subList.filter(
        (ele) => ele.code == name
      );
      this.changeList(trueArr[0]);
    },
    handleCurrentChange(val) {
      this.params.pageIndex = val;
      this.getList();
    },
    getList() {
      //获取列表
      sysNewsList(this.params).then((res) => {
        if (res.code === 0) {
          this.newsList = res.data.list;
          this.newsTotal = res.data.total;
        }
      });
    },
    // nav 改变事件
    changeList(item) {
      this.activeItem = item;
      this.activeCode = item.code;

      this.params = {
        newsCode: item.code,
        pageIndex: 1,
        pageSize: 10,
      };
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@function pxToRem($args) {
  @return $args / 50 + rem;
}

.about-frame {
  .box,
  .m-box {
    width: 1200px;
    margin: 60px auto;

    .nav {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;

      .nav-item {
        font-size: 18px;
        margin-bottom: 10px;
        line-height: 40px;
        position: relative;

        &::after {
          content: "";
          display: inline-block;
          width: 0;
          height: 2px;
          background-color: $theme;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          transition: width 0.3s;
        }

        &:hover {
          cursor: pointer;
          color: $theme;

          &::after {
            width: 100%;
          }
        }
      }
      .on {
        color: $theme;
      }
    }
    .new-list {
      width: 1040px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      text-align: center;
      margin-top: 60px;

      .new-item {
        // width: 290px;
        margin-right: 10px;
        margin-bottom: 10px;
        transition: all 0.3s;
        &:hover {
          cursor: pointer;
          box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
        }

        img {
          width: 290px;
          height: 290px;
          display: block;
        }
        .video {
          width: 500px;
          height: 325px;
        }

        .desc {
          margin-bottom: 10px;
        }
      }
    }
  }
}
.about-frame .m-box {
  width: 100%;
  margin: 0 0 pxToRem(30);

  .new-list {
    width: 100%;
    padding: 0 pxToRem(20);
    margin-top: 0;
    box-sizing: border-box;

    .new-item {
      .video {
        width: pxToRem(150);
        height: pxToRem(100);
      }
      .img-show {
        width: pxToRem(150);
        height: pxToRem(150);
      }
      img {
        width: 100%;
        max-height: 100%;
      }
    }
  }
}
</style>
